var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.txtInfo,"placement":"top","effect":"dark","disabled":_vm.isDisabled}},[_c('div',{staticClass:"wordnowrap",on:{"mouseenter":_vm.isShowTooltip}},[_vm._v(_vm._s(_vm.txtInfo))])])}
var staticRenderFns = []

export { render, staticRenderFns }